/* eslint-disable  */
//@ts-nocheck

import React from 'react';
import ReactDOM from 'react-dom';

type TooltipProps = {
  className?: string;
  size?: 'small';
};
class Tooltip extends React.Component<React.PropsWithChildren<TooltipProps>> {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      position: {},
      offset: this.props.offset ? this.props.offset : 10,
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onClick = this.onClick.bind(this);
  }
  componentDidMount() {
    document.addEventListener('click', this.onDocumentClick, true);
    document.addEventListener('touchstart', this.onDocumentClick, true);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.onDocumentClick, true);
    document.removeEventListener('touchstart', this.onDocumentClick, true);
  }
  onDocumentClick(e) {
    // https://github.com/kentor/react-click-outside/blob/master/dist/index.js
    var domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(e.target)) {
      // click happened outside component
      this.setState({ open: false });
    }
  }
  onClick(ev) {
    if (ev.target.getBoundingClientRect) {
      // get tooltip position
      var tt = ev.target.getBoundingClientRect();
      // override or calculate responsive popup width & height
      var width = this.props.width;
      var height = this.props.height;
      if (this.props.size && this.props.size === 'small') {
        width = 270;
        height = 270;
      }
      if (!width || !height) {
        if (
          window.innerHeight > 270 + this.state.offset &&
          window.innerWidth > 910
        ) {
          width = 540;
          height = 270;
        } else {
          width = 270;
          height = 270;
        }
      }
      // calculate content positioning
      var position = {};
      if (
        window.innerHeight - tt.top - tt.height - this.state.offset - height >
        0
      ) {
        // content goes UNDER the tooltip
        position.top = tt.top + tt.height + this.state.offset;
        if (tt.left + tt.width > width) {
          // content goes LEFT of tooltip
          position.left = tt.left + tt.width - width;
        } else if (tt.left + width < window.innerWidth) {
          // content goes RIGHT of tooltip
          position.left = tt.left;
        } else {
          // content goes CENTER of tooltip
          position.left = tt.left + tt.width / 2 - width / 2;
        }
      } else {
        // content goes OVER the tooltip
        position.top = tt.top - height - this.state.offset;
        if (tt.left + tt.width > width) {
          // content goes LEFT of tooltip
          position.left = tt.left + tt.width - width;
        } else if (tt.left + width < window.innerWidth) {
          position.left = tt.left;
        } else {
          // content goes CENTER of tooltip
          position.left = tt.left + tt.width / 2 - width / 2;
        }
      }
      this.setState({
        open: !this.state.open,
        width: width,
        height: height,
        position: position,
      });
    }
  }
  render() {
    var contentClass = this.state.open
      ? 'tooltip-content open'
      : 'tooltip-content';
    if (this.props.size && this.props.size === 'small') {
      contentClass += ' small';
    }
    var tooltipClass = this.props.className
      ? `tooltip ${this.props.className}`
      : 'tooltip';
    return (
      <div className="tooltipContainer">
        <span className={tooltipClass} onClick={this.onClick}></span>
        <div className={contentClass} style={this.state.position}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Tooltip;
